module.exports = __webpack_public_path__ + "img/TARIJA.1d5a3024.png";